<template>
  <!-- 管理员-某一教育机关员工管理-->
  <div class="main-css">
    <!--标题-->
    <div class="title-css">{{ $t("staffManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("new")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 95%"
          height="430"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------社員番号---------------------- -->
          <el-table-column
            prop="userId"
            label="社員番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("memberMumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.userId }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="userName"
            label="氏名"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              <!--              <img src="./assets/image.png" alt="" class="table-img-css" />-->
              <span style="margin-left: 10px">{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <!-- ---------------------権限-------------------- -->
          <el-table-column label="権限" min-width="130" :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("limit") }}</p>
              <el-dropdown @command="handleCommanduserRights">
                <span class="el-dropdown-link">
                  {{ userRightsName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in userRightsData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'JP'">{{
                scope.row.jproleName_dictText
              }}</span>
              <span v-else>{{ scope.row.roleName_dictText }}</span>
            </template>
          </el-table-column>

          <!-- ----------------------ユーザーID---------------------- -->
          <el-table-column
            prop="emailAddress"
            label="ユーザーID"
            width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("userID") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.emailAddress }}</span>
            </template>
          </el-table-column>
          <!-- -----------------------担当案件数----------------------- -->
          <el-table-column
            prop="casesNumber"
            label="担当案件数"
            width="80"
            sortable
          >
            <template slot="header">
              <p>{{ $t("numberOfCases") }}</p>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.casesNumber }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column label="操作" fixed="right" width="350">
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button
                class="right-button1"
                @click="reviseMedicalUser(scope.row)"
              >
                {{ $t("edit") }}
              </button>
              <button
                v-if="scope.row.userStatus == 0"
                @click="stopMedicalUser(scope.row)"
                class="right-button2"
              >
                {{ $t("stopUsing") }}
              </button>
              <button
                v-if="scope.row.userStatus == 1"
                @click="stopMedicalUser(scope.row)"
                class="right-button2"
              >
                {{ $t("startUsing") }}
              </button>
              <button
                @click="deleteMedicalUser(scope.row)"
                class="right-button3"
              >
                {{ $t("delete") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!--      新增教育机构员工弹出层      -->
      <template>
        <div v-if="dialogAddShow">
          <!-- 登录的操作部分 -->
          <div class="login-main">
            <div class="register">
              <div class="box-top">
                <div class="top-icon" @click="handleCloseDialog">
                  <img
                    src="./assets/Arrow_Right_LG.png"
                    alt=""
                    @error="
                      e => {
                        e.target.src = require('@/assets/defaultImg.png');
                      }
                    "
                  />
                </div>
              </div>
              <div class="box-bottom">
                <div class="bottom-box-title">
                  <p class="welcome">Welcome!</p>
                  <p class="ja-welcome">
                    <span>{{ $t("newEducationUser") }}</span>
                    <el-dropdown
                      class="welcom-dropdown"
                      @command="handleCommand1"
                    >
                      <span class="el-dropdown-link">
                        {{ lang
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">{{
                          $t("chinese")
                        }}</el-dropdown-item>
                        <el-dropdown-item command="1">{{
                          $t("japanese")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </p>
                </div>
                <!-- 表单部分 -->
                <div class="box-big">
                  <!-- 表单部分 -->
                  <div class="box-form">
                    <!-- 头像选择 -->
                    <div class="Avatar">
                      <div
                        class="Avatar-img"
                        @click="toGetImg"
                        v-if="!imageUrl1"
                      >
                        <p class="Avatar-img-icon">
                          <img src="./assets/Image_01.svg" alt="" />
                        </p>
                        <p class="Avatar-img-title">{{ $t("photograph") }}</p>
                      </div>
                      <div
                        class="Avatar-img"
                        @click="toGetImg"
                        v-if="imageUrl1"
                      >
                        <img
                          :src="imageUrl1"
                          alt=""
                          class="Avatar-img-main-css"
                        />
                      </div>
                    </div>
                    <!-- 用户名	input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("userName") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/User_01.svg"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="text"
                          name=""
                          id="userName"
                          v-model="userName1"
                          class="pop-input-css-main"
                          @blur="registerData(4)"
                        />
                        <span v-if="userNameShow" class="emil-true-css">
                          {{ $t("userNameRules") }}</span
                        >
                      </div>
                    </div>
                    <!-- 邮箱input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("emil") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/Vector (1).png"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="text"
                          name=""
                          id="emilData"
                          class="pop-input-css-main"
                          v-model="emilData1"
                          @blur="registerData(1)"
                        />
                      </div>
                      <span v-if="emilShow" class="emil-true-css">
                        {{ $t("emilError") }}</span
                      >
                    </div>
                    <!-- 密码input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("password") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/Vector.png"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="password"
                          id="passWordData"
                          class="pop-input-css-main"
                          v-model="passWordData1"
                          @blur="registerData(2)"
                        />
                      </div>
                      <span v-if="passWordShow" class="emil-true-css">
                        {{ $t("passwordRules") }}</span
                      >
                    </div>
                    <!-- 确认密码input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("confirmPassword") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/Vector.png"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="password"
                          name=""
                          id="insurePassWordData"
                          class="pop-input-css-main"
                          v-model="insurePassWordData1"
                          @blur="registerData(3)"
                        />
                      </div>
                      <span v-if="insurePassWordShow" class="emil-true-css">
                        {{ $t("twoPassword") }}</span
                      >
                    </div>
                  </div>
                  <!-- 确定按钮 -->
                  <div class="insure">
                    <button class="insure-button" @click="adminAdd">
                      {{ $t("confirm") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!--      修改教育机构员工弹出层      -->
      <template>
        <div v-if="dialogReviseShow">
          <!-- 登录的操作部分 -->
          <div class="login-main">
            <div class="register">
              <div class="box-top">
                <div class="top-icon" @click="handleCloseDialog">
                  <img src="./assets/Arrow_Right_LG.png" alt="" />
                </div>
              </div>
              <div class="box-bottom">
                <div class="bottom-box-title">
                  <p class="welcome">Welcome!</p>
                  <p class="ja-welcome">
                    <span>{{ $t("reviseEducationUser") }}</span>
                    <el-dropdown
                      class="welcom-dropdown"
                      @command="handleCommand1"
                    >
                      <span class="el-dropdown-link">
                        {{ lang
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">{{
                          $t("chinese")
                        }}</el-dropdown-item>
                        <el-dropdown-item command="1">{{
                          $t("japanese")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </p>
                </div>
                <!-- 表单部分 -->
                <div class="box-big">
                  <!-- 表单部分 -->
                  <div class="box-form">
                    <!-- 头像选择 -->
                    <div class="Avatar">
                      <div
                        class="Avatar-img"
                        @click="toGetImg"
                        v-if="!imageUrl2"
                      >
                        <p class="Avatar-img-icon">
                          <img src="./assets/Image_01.svg" alt="" />
                        </p>
                        <p class="Avatar-img-title">{{ $t("photograph") }}</p>
                      </div>
                      <div
                        class="Avatar-img"
                        @click="toGetImg"
                        v-if="imageUrl2"
                      >
                        <img
                          :src="imageUrl2"
                          alt=""
                          class="Avatar-img-main-css"
                        />
                      </div>
                    </div>
                    <!-- 用户名	input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("userName") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/User_01.svg"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="text"
                          name=""
                          id="userName2"
                          v-model="userName2"
                          class="pop-input-css-main"
                          @blur="registerData2(4)"
                        />
                        <span v-if="userNameShow" class="emil-true-css">
                          {{ $t("userNameRules") }}</span
                        >
                      </div>
                    </div>
                    <!-- 邮箱input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("emil") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/Vector (1).png"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="text"
                          name=""
                          id="emilData2"
                          class="pop-input-css-main"
                          v-model="emilData2"
                          @blur="registerData2(1)"
                        />
                      </div>
                      <span v-if="emilShow" class="emil-true-css">
                        {{ $t("emilError") }}</span
                      >
                    </div>
                    <!-- 密码input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{ $t("password") }}</p>
                      <div class="pop-input-css">
                        <img
                          src="./assets/Vector.png"
                          alt=""
                          class="emil-icon"
                        />
                        <input
                          type="password"
                          id="passWordData2"
                          class="pop-input-css-main"
                          v-model="passWordData2"
                          @blur="registerData2(2)"
                        />
                      </div>
                      <span v-if="passWordShow" class="emil-true-css">
                        {{ $t("passwordRules") }}</span
                      >
                    </div>
                  </div>
                  <!-- 确定按钮 -->
                  <div class="insure">
                    <button class="insure-button" @click="reviseClick">
                      {{ $t("confirm") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  addMedicalInstitutionUserInfo,
  deleteEducationPerson,
  deleteMedicalInstitutionUserInfo,
  getUrlFromOSS,
  InsertEducationPerson,
  queryAppointInsAllUser,
  updateEducationPerson,
  updateMedicalInstitutionUserInfo
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "administratorsOnlyEducationStaffManagement",
  components: {},
  data() {
    return {
      avatar: "",
      avatarUrl: "",
      imageUrl1: "", //头像图片地址路径
      userName1: "", //用户名
      userNameShow: false,
      emilData1: "", //emil数据
      emilShow: false,
      passWordData1: "", //密码数据
      passWordShow: false,
      insurePassWordData1: "", //确认密码数据
      insurePassWordShow: false,
      imageUrl2: "", //头像图片地址路径
      userName2: "", //用户名
      emilData2: "", //emil数据
      passWordData2: "", //密码数据
      lang: "JP", //语言

      educationId: "",
      userId: "",
      reviewStatus: "",
      emailAddress: "",
      casesNumber: "",
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      permission: "All",
      cases: "All",
      dialogAddShow: false, //dialog标识
      dialogReviseShow: false,
      totalNum: 0,
      userRights: "",
      userRightsName: "All",
      userRightsCode: "",
      userRightsData: [],
      language: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();
    this.educationId = this.$route.query.educationId;
    this.queryList();
    this.getuserRights();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.queryList();
        this.getuserRights();
      }
    },
    //语言转换
    handleCommand1(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.userRights = "userRights";
      } else {
        this.userRights = "jpuserRights";
      }
      console.log(this.userRights);
    },
    //获取userRights下拉
    handleCommanduserRights(evt) {
      this.userRightsCode = evt.code;
      this.userRightsName = evt.name;
    },
    getuserRights() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.userRights
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据userRights--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.userRightsData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.userRightsData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    // input校验
    registerData(num) {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      var password = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/;
      var userNameRule = /^.{4,32}$/;
      if (num === 1) {
        if (reg.test(this.emilData1)) {
          this.emilShow = false;
        } else {
          this.emilShow = true;
        }
      } else if (num === 2) {
        if (password.test(this.passWordData1)) {
          this.passWordShow = false;
        } else {
          this.passWordShow = true;
        }
      } else if (num === 3) {
        if (this.insurePassWordData1 !== this.passWordData1) {
          this.insurePassWordShow = true;
        } else {
          this.insurePassWordShow = false;
        }
      } else if (num === 4) {
        if (userNameRule.test(this.userName1)) {
          this.userNameShow = false;
        } else {
          this.userNameShow = true;
        }
      }
    },
    // input校验2
    registerData2(num) {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      var password = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/;
      var userNameRule = /^.{4,32}$/;
      if (num === 1) {
        if (reg.test(this.emilData2)) {
          this.emilShow = false;
        } else {
          this.emilShow = true;
        }
      } else if (num === 2) {
        if (password.test(this.passWordData2)) {
          this.passWordShow = false;
        } else {
          this.passWordShow = true;
        }
      } else if (num === 4) {
        if (userNameRule.test(this.userName2)) {
          this.userNameShow = false;
        } else {
          this.userNameShow = true;
        }
      }
    },
    //新增教育机构用户
    adminAdd() {
      var fakeInfo = {
        avatar: this.avatar, //头像地址
        emailAddress: this.emilData1, //邮箱
        educationId: this.educationId,
        password: this.insurePassWordData1, //密码
        userName: this.userName1 //用户名
      };
      InsertEducationPerson(fakeInfo)
        .then(res => {
          console.log("新增教育机构用户接口数据:", res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("addedSuccessfully"),
              type: "success"
            });
            this.clear();
            this.queryList();
            this.dialogAddShow = false;
          } else if (res.data.code === "A0154") {
            this.$message({
              message: this.$t("theUserAlreadyExists"),
              type: "warning"
            });
          } else {
            this.$message.error(this.$t("addFailed"));
          }
        })
        .catch(res => {
          console.log("新增教育机构用户接口数据异常:", res);
        });
    },
    clear() {
      this.imageUrl1 = "";
      this.userName1 = "";
      this.emilData1 = "";
      this.passWordData1 = "";
      this.insurePassWordData1 = "";
      this.imageUrl2 = "";
      this.userName2 = "";
      this.emilData2 = "";
      this.passWordData2 = "";
      this.userNameShow = false;
      this.emilShow = false;
      this.passWordShow = false;
      this.insurePassWordShow = false;
    },
    //删除教育机构用户
    deleteMedicalUser(row) {
      var fakeInfo = {
        educationId: this.educationId,
        userId: row.userId
      };
      axios({
        method: "delete",
        url: "/api/modules-parent/educationalQuery/deleteEducationPerson",
        data: fakeInfo,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("-----删除教育机构用户-----");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("successfullyDeleted"),
              type: "success"
            });
            this.queryList();
          } else {
            this.$message.error(this.$t("failedToDelete"));
          }
        })
        .catch(res => {});
    },

    reviseMedicalUser(row) {
      this.dialogReviseShow = true;
      this.getUrl(row.avatar);
      this.userName2 = row.userName;
      this.emilData2 = row.emailAddress;
      this.userId = row.userId;
    },
    //修改图片回显
    getUrl(url) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.imageUrl2 = aesFecInfo.message;
          }
        })
        .catch(() => {});
    },
    //修改员工
    reviseClick() {
      var fakeInfo = {
        avatar: this.avatar, //头像地址
        emailAddress: this.emilData2, //邮箱
        educationId: this.educationId,
        password: this.passWordData2, //密码
        userName: this.userName2, //用户名
        applyAdmin: 0,
        casesNumber: 0,
        reviewStatus: 0,
        userId: this.userId,
        userStatus: 0
      };
      updateEducationPerson(fakeInfo)
        .then(res => {
          console.log("修改教育机构用户接口数据:", res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
            this.clear();
            this.queryList();
            this.dialogReviseShow = false;
          } else {
            this.$message.error(this.$t("failToEdit"));
          }
        })
        .catch(res => {
          console.log("修改教育机构用户接口数据异常:", res);
        });
    },
    //停用教育机构用户
    stopMedicalUser(row) {
      var that = this;
      const params = new URLSearchParams();
      params.append("userId", row.userId);
      axios
        .post(
          "/api/modules-parent/educationalQuery/deadStatusEducationUser",
          params,
          {
            headers: {
              //头部参数
              "Content-Type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          }
        )
        .then(function(res) {
          console.log("停用教育机构用户接口", res);
          if (res.data.code === "A0000") {
            that.$message({
              message: that.$t("successfulOperation"),
              type: "success"
            });
            that.queryList();
          } else {
            that.$message.error(that.$t("operationFailed"));
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryList() {
      var fakeInfo = {
        educationId: this.educationId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryAppointInsAllUser(fakeInfo)
        .then(res => {
          console.log("-----查询教育机构所属员工-----");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          this.tableData = aesFecInfo.data;
          this.totalNum = aesFecInfo.total;
          console.log(aesFecInfo);
        })
        .catch(res => {});
    },

    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleAddClick() {
      this.dialogAddShow = true; //dialog标识
      console.log("＋新たなbutton");
    },
    //dialog 关闭
    handleCloseDialog() {
      this.dialogAddShow = false;
      this.dialogReviseShow = false;
      this.userNameShow = false;
      this.emilShow = false;
      this.passWordShow = false;
      this.insurePassWordShow = false;
    },
    //下拉1
    dropdown1(command) {
      if (command === "a") {
        console.log(this.dropdown1);
        console.log("点击管理员");
      } else if (command === "b") {
        console.log(this.dropdown1);
        console.log("点击员工");
      }
    },
    //下拉2
    dropdown2(command) {
      console.log(command);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.currentPage = 1;
      this.queryList();
    },
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.imageUrl1 = this.result;
            that.imageUrl2 = this.result;
            console.log(this.result);
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function(res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.avatar = aesFecInfo.path;
                  that.avatarUrl = aesFecInfo.url;
                  console.log(that.avatar);
                  console.log(that.avatarUrl);
                }
              })
              .catch(function(error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}
.button-css {
  width: 200px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  width: 100%;
  margin-top: 10px;
  height: 420px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}
.operate {
  height: 51px;
}
.table /deep/ .el-dropdown {
  width: 60px;
}
.table-img-css {
  border-radius: 50%;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}
.right-button1 {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
  margin-right: 5px;
}
.right-button2 {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
  margin-right: 5px;
}
.right-button3 {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
}
.pagination {
  width: 95%;
  height: 50px;
  margin-top: 20px;
}
.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}
.register {
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
  width: 404px;
  height: 630px;
  position: absolute;
  margin-left: 400px;
  margin-top: -570px;
  z-index: 5;
}
.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}
.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}
.box-bottom {
  height: 630px;
  padding: 0 40px;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}
.welcome {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}

.ja-welcome {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
}
.main-box /deep/ .el-table::before {
  height: 0px;
}
.box-big {
  width: 310px;
  overflow: hidden;
}

.box-form {
  margin-top: 30px;
  height: 400px;
  width: 330px;
}
.pop-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}

.pop-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.pop-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 300px;
  box-sizing: border-box;
}
.pop-input-css-main {
  width: 230px;
  height: 37px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}
.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}
.emil-true-css {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
  display: inline-block;
  margin-left: 0px;
  color: #f56c6c;
}
.pop-input-css-main /deep/ .el-input__inner {
  height: 38px;
}
.insure {
  height: 50px;
  margin-top: 13px;
  margin-bottom: 10px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 280px;
  height: 50px;
  margin-left: 10px;
}
.Avatar-img {
  margin-top: 12px;
  width: 90px;
  height: 90px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
  align-content: center;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorsOnlyEducationStaffManagement/index.vue